import EventEmitter from "eventemitter3";
import {Power2, TimelineMax, TweenMax} from "gsap";
import Swiper from 'swiper'

export class Navigation extends EventEmitter {

    constructor(viewport) {
        super();

        this.viewport = viewport;
        this.state = {
            nav_active: false,
            spec_active: false
        };
        // Swiper. not yet.
        // this.swiper = new Swiper('.swiper-container', {
        //         autoplay: false,
        //         speed: 700,
        //         loop: true,
        //         pagination: {
        //             el: '.swiper-pagination',
        //             type: 'bullets',
        //             clickable: true,
        //             renderBullet: function (index, className) {
        //                 return '<span class="' + className + '"><img src="assets/images/thumb.jpg"/></span>';
        //             }
        //         },
        //         on: {
        //             slideChangeTransitionStart() {
        //                 // let $slide = $$(this.$el).find(' .swiper-slide').eq(this.realIndex);
        //                 // let curVideo = $slide.find('video');
        //                 // if (curVideo && curVideo[0]) {
        //                 //     let promise = curVideo[0].pause();
        //                 //     if (promise !== undefined) {
        //                 //         promise.catch(error => {
        //                 //             // Auto-play was prevented
        //                 //             // Show a Unmute/Play Button to let the user manually start playback
        //                 //             // self._triggerUnmuteButton();
        //                 //             // self.videoEl.muted = true;
        //                 //             // self.videoEl.play();
        //                 //         }).then(() => {
        //                 //             // Auto-play started
        //                 //         });
        //                 //     }
        //                 //
        //                 // }
        //             },
        //             slideChangeTransitionEnd() {
        //                 // let $slide = $$(this.$el).find(' .swiper-slide').eq(this.realIndex);
        //                 // let curVideo = $slide.find('video');
        //                 // if (curVideo && curVideo[0]) {
        //                 //     let promise = curVideo[0].play();
        //                 //     if (promise !== undefined) {
        //                 //         promise.catch(error => {
        //                 //             // Auto-play was prevented
        //                 //             // Show a Unmute/Play Button to let the user manually start playback
        //                 //             // self._triggerUnmuteButton();
        //                 //             // self.videoEl.muted = true;
        //                 //             // self.videoEl.play();
        //                 //         }).then(() => {
        //                 //             // Auto-play started
        //                 //         });
        //                 //     }
        //                 // }
        //
        //             }
        //         }
        //
        //     }
        // )
        ;

        // Timeline for navToggle
        this.timelineNav = new TimelineMax({paused: true});

        this
            .timelineNav
            .set(
                '#ovl_nav'
                , {
                    "display": "none"
                }
            )
            .set('#ovl_nav', {"display": "block"})
            .to('#ovl_nav .screen', 0.2, {
                width: '0',
                height: '0',
                background: '#ffffff'
            })
            .to('#ovl_nav .screen', 0.2, {
                width: '100%',
                height: '2px',
                background: '#ffffff',
                ease: Power2.easeOut
            })
            .to('#ovl_nav .screen', 0.6, {
                height: '100%',
                background: '#ffffff',
                ease: Power2.easeOut
            }).call(() => {
            this.emit('nav:overlay_active');
        });


// timeline for spec toggle
        this.timelineSpecs = new TimelineMax({
            paused: true
        });

        this.timelineSpecs
            .call(() => {
                // this.swiper.autoplay.stop();
            })
            .set('#ovl_specs', {"display": "none"})
            .set('#ovl_specs', {"display": "block"})
            .to('#ovl_mask', 0.3, {"display": "block", opacity: 1})
            .to('#ovl_specs .screen', 0.2, {
                width: '0',
                height: '0',
                background: '#ffffff'
            })
            .to('#ovl_specs .screen', 0.2, {
                width: '100%',
                height: '2px',
                ease: Power2.easeOut
            })
            .to('#ovl_specs .screen', 0.6, {
                height: '100%',
                background: '#ffffff',
                ease: Power2.easeOut
            })
            .call(() => {
                this.emit('nav:overlay_active');
                // Start Swiper
                // this.swiper.update();
                // START AUTOPLAY?
                // this.swiper.autoplay.start(6000);
            });


        this._addEvents = this._addEvents.bind(this);

        this._addEvents();
    }

// ------------------------------------------------------------------------------------------------
// Public
// ------------------------------------------------------------------------------------------------

    toggleNav(e) {
        e.preventDefault();
        this.hideAllOverlays();
        if (!this.state.nav_active) {
            this.timelineNav.play();
            document.body.classList.add('nav__out');
        }
        this.state.nav_active = !this.state.nav_active;
    }

    toggleSpecs(e) {
        e.preventDefault();
        this.hideAllOverlays();
        if (!this.state.spec_active) {
            TweenMax.set('#ovl_specs video', {opacity: 1});
            this.timelineSpecs.play();
            document.body.classList.add('spec__out');
        }
        this.state.spec_active = !this.state.spec_active;
    }

    hideAllOverlays() {
        document.body.classList.remove('nav__out');
        this.state.nav_active = false;
        this.timelineNav.reverse();
        document.body.classList.remove('nav__out');

        // Specs
        document.body.classList.remove('spec__out');
        this.state.spec_active = false;
        this.timelineSpecs.reverse();

        this.emit('nav:overlay_inactive');

    }

// ------------------------------------------------------------------------------------------------
// Private
// ------------------------------------------------------------------------------------------------

    /**
     * Centralised CLICK Listener
     * @private
     */
    _addEvents() {

        // -----------------------------------------------------------------------------------------------
        // Controls : Change child video src, navigate
        // CONTROLS : nav | video
        // COMMANDS : video_uri | home |
        //
        $('.btn').on('click', (e) => {
            let control = $(e.currentTarget).data('control');
            let command = $(e.currentTarget).data('command');
            e.preventDefault(); // Only block default action if there is a data-command, better: use a [data] selector for the eventlistener

            // No action on disabled buttons
            if ($$(e.currentTarget).hasClass('disabled')) return;

            if (control === 'video') {
                this.emit('nav:video', command);
            } else if (control === 'home') {
                window.location = command;
                return;
            }


            // Apply new child video and set state to 'child'
            switch (command) {
                // Specs overlay
                case 'specs' :
                    this.toggleSpecs(e);
                    break;
                // Navigation overlay (PDFs)
                case 'navtoggle' :
                    console.log('toggle nav')
                    this.toggleNav(e);
                    break;
                // Close buttons
                case 'close' :
                    this.hideAllOverlays();
                    break;
            }
        });
    }

    _removeEvents() {
        $('.btn').off('click');
    }

}
